const RELOAD_FLAG = "msb:chunk-reload-at";

const RELOAD_WINDOW_MS = 10_000;

const CHUNK_ERROR_RE =
  /ChunkLoadError|Loading (CSS )?chunk [\w-]+ failed|Loading chunk \d+ failed/i;

function isChunkLoadError(err) {
  if (!err) return false;
  if (err.name === "ChunkLoadError") return true;
  const msg = typeof err === "string" ? err : err.message || "";
  return CHUNK_ERROR_RE.test(msg);
}

function recover() {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
    if (Date.now() - last < RELOAD_WINDOW_MS) return; // already reloaded - avoid loop
    sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  } catch {}
  window.location.reload();
}

// React.lazy failures are thrown during render and caught by ErrorBoundary,
// so they never reach the window listeners below.
export function reloadOnChunkLoadError(err) {
  if (!isChunkLoadError(err)) return false;
  recover();
  return true;
}

export function initChunkReload() {
  // Dynamic import() rejections surface as unhandled promise rejections.
  window.addEventListener("unhandledrejection", (e) => {
    if (isChunkLoadError(e.reason)) recover();
  });
  // Some chunk/script load failures surface as error events instead.
  window.addEventListener("error", (e) => {
    if (isChunkLoadError(e.error) || isChunkLoadError(e.message)) recover();
  });
}
